<template>
  <div class="form-group row">
    <label for="inputTransitDescription" class="col-12 col-form-label">Описание техцентра</label>
    <div class="col-12">
      <mavon-editor
        id="inputTransitDescription"
        v-model="text"
        :toolbars="toolbars"
        language="ru"
        @input="$emit('input', text)"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TcTextArea',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      text: this.value === null ? '' : this.value,
      // TODO если pull-request примут то можно будет поменять на русский @see https://github.com/hinesboy/mavonEditor/pull/274
      toolbars: {
        bold: true,
        italic: true,
        header: true,
        underline: true,
        strikethrough: true,
        mark: true,
        superscript: true,
        subscript: true,
        quote: true,
        ul: true,
        link: true,
        undo: true,
        redo: true,
        alignleft: true,
        aligncenter: true,
        alignright: true,
        subfield: true,
        preview: true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.v-note-wrapper {
  min-height: 500px;
}
</style>



// WEBPACK FOOTER //
// TcTextArea.vue?3b727abb